<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 125.859 49.566"
  >
    <g id="Group_6" data-name="Group 6" transform="translate(-252.873 -509.677)">
      <g id="Group_3" data-name="Group 3" transform="translate(252.873 546.341)">
        <g id="Group_1" data-name="Group 1" transform="translate(0 0)">
          <path
            id="Path_11"
            data-name="Path 11"
            d="M256.418,807.111V813.4h-3.545V800.991H255.9l5.884,6.309v-6.309h3.545V813.4h-3.048Z"
            transform="translate(-252.873 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_12"
            data-name="Path 12"
            d="M366.561,806.136a6.435,6.435,0,0,1,.5-2.528,6.162,6.162,0,0,1,1.418-2.056,6.521,6.521,0,0,1,2.245-1.371,8.33,8.33,0,0,1,2.954-.5,9.142,9.142,0,0,1,2.836.425,6.612,6.612,0,0,1,2.269,1.252,5.518,5.518,0,0,1,1.489,2.009,6.64,6.64,0,0,1,.544,2.717,6.267,6.267,0,0,1-.52,2.623,6.037,6.037,0,0,1-1.489,2.032,6.752,6.752,0,0,1-2.269,1.323,8.5,8.5,0,0,1-2.836.473,9.142,9.142,0,0,1-2.836-.425,6.611,6.611,0,0,1-2.269-1.252,5.6,5.6,0,0,1-1.489-2.032,6.75,6.75,0,0,1-.52-2.741Zm3.946,0a2.639,2.639,0,0,0,.236,1.134,2.867,2.867,0,0,0,.662.922,3.053,3.053,0,0,0,.993.614,3.4,3.4,0,0,0,1.205.213,4.263,4.263,0,0,0,1.418-.213,2.359,2.359,0,0,0,.969-.614,2.575,2.575,0,0,0,.543-.922,3.565,3.565,0,0,0,.189-1.134,2.615,2.615,0,0,0-.874-2.127,3.309,3.309,0,0,0-2.2-.756,3.243,3.243,0,0,0-2.221.756,2.675,2.675,0,0,0-.851,2.127Z"
            transform="translate(-352.17 -799.638)"
            fill="#2f3042"
          />
          <path
            id="Path_13"
            data-name="Path 13"
            d="M494.622,800.8h4.726a9.746,9.746,0,0,1,2.694.331,4.8,4.8,0,0,1,1.772.9,3.178,3.178,0,0,1,.969,1.394,5.361,5.361,0,0,1,.284,1.772,5.192,5.192,0,0,1-.213,1.607,4.46,4.46,0,0,1-.5,1.063,2.727,2.727,0,0,1-.591.662,5.485,5.485,0,0,1-.5.354l3.072,4.348h-4.8l-2.127-3.426H498.4v3.426h-3.781Zm5.033,3.545h-.709a2.89,2.89,0,0,0-.5.023v1.891h1.087a2.416,2.416,0,0,0,1.134-.213.844.844,0,0,0,.331-1.063.721.721,0,0,0-.236-.307,1.609,1.609,0,0,0-.449-.26,2.066,2.066,0,0,0-.733-.118Z"
            transform="translate(-464.02 -800.616)"
            fill="#2f3042"
          />
          <path
            id="Path_14"
            data-name="Path 14"
            d="M594.247,800.991v3.545h-3.97V813.4H586.5v-8.862H582.55v-3.545Z"
            transform="translate(-540.818 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_15"
            data-name="Path 15"
            d="M690.123,808.836V813.4h-3.781V800.991h3.781v4.3h4.608v-4.3h3.781V813.4h-3.781v-4.561Z"
            transform="translate(-631.471 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_16"
            data-name="Path 16"
            d="M809.413,800.991v6.664l4.986-6.664h3.5v6.38l4.324-6.38h4.537L817.613,813.4h-3.237v-6.5l-5.033,6.5h-3.71V800.991Z"
            transform="translate(-735.66 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_17"
            data-name="Path 17"
            d="M980.972,800.991V813.4h-3.781V800.991Z"
            transform="translate(-885.502 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_18"
            data-name="Path 18"
            d="M1034.686,807.111V813.4h-3.545V800.991h3.025l5.884,6.309v-6.309h3.545V813.4h-3.048Z"
            transform="translate(-932.623 -800.778)"
            fill="#2f3042"
          />
          <path
            id="Path_19"
            data-name="Path 19"
            d="M1157.942,804.368v6.073a5.61,5.61,0,0,1-1.111.709,11.516,11.516,0,0,1-1.347.567,7.777,7.777,0,0,1-1.418.354,9.2,9.2,0,0,1-1.371.118,10.58,10.58,0,0,1-3.285-.473,6.974,6.974,0,0,1-2.41-1.323,5.463,5.463,0,0,1-1.489-2.032,6.656,6.656,0,0,1-.5-2.623,6.288,6.288,0,0,1,.5-2.481,6.164,6.164,0,0,1,1.418-2.056,6.452,6.452,0,0,1,2.268-1.394,8.731,8.731,0,0,1,3.025-.5,8.187,8.187,0,0,1,2.718.378,8.662,8.662,0,0,1,1.985.993l-1.583,2.954a6.234,6.234,0,0,0-1.158-.5,4.7,4.7,0,0,0-1.489-.26,6.872,6.872,0,0,0-1.418.142,3.4,3.4,0,0,0-1.158.473,2.159,2.159,0,0,0-.78.874,3.015,3.015,0,0,0-.283,1.37,2.559,2.559,0,0,0,.992,2.127,4.248,4.248,0,0,0,2.694.78,5.618,5.618,0,0,0,.922-.071,5.028,5.028,0,0,0,.756-.189v-.709h-2.694v-3.308Z"
            transform="translate(-1032.083 -799.311)"
            fill="#2f3042"
          />
        </g>
      </g>
      <g id="Group_5" data-name="Group 5" transform="translate(286.295 509.677)">
        <g id="zhTL12" transform="translate(0 0)">
          <g id="Group_4" data-name="Group 4">
            <path
              id="Path_29"
              data-name="Path 29"
              d="M546.844,512.344a.452.452,0,0,1,.377-.664,13.351,13.351,0,0,1,7.516,1.54,9.182,9.182,0,0,1,4.3,4.854,26.92,26.92,0,0,1,.693,2.892,12.932,12.932,0,0,1,1.19.862,5.781,5.781,0,0,1,1.088,1.194c.522.823.2,1.343-.773,1.343-4.925,0-9.851.039-14.775-.023a4.533,4.533,0,0,0-2.107.419,4.132,4.132,0,0,0-1.321,1.05c-2.044,2.36-8.985,9.405-9.921,8.79a.683.683,0,0,1-.22-.277c-.153-.356.063-.775.154-1.141.811-3.245,1.644-6.485,2.472-9.726v-.005a.777.777,0,0,1,.709-.585c.055,0,.11,0,.165,0,1.285,0,2.571,0,3.857,0a1.175,1.175,0,0,0,.584-.057c.219-.142.5-.375.516-.591a.958.958,0,0,0-.407-.664,1.215,1.215,0,0,0-.676-.109c-2.408-.007-4.816,0-7.225-.009a2.874,2.874,0,0,1-.853-.117,1.392,1.392,0,0,1-.995-1.344,1.454,1.454,0,0,1,1.164-1.274,4.544,4.544,0,0,1,.864-.067c1.557-.006,3.114,0,4.672,0,.163,0,.326,0,.489-.005.552-.034.92-.339.9-.741s-.4-.678-.956-.678c-2.933,0-5.867,0-8.8-.009a3.544,3.544,0,0,1-1.065-.15,1.431,1.431,0,0,1-.987-1.359,1.412,1.412,0,0,1,.995-1.3,2.947,2.947,0,0,1,.957-.146c2.1-.012,4.2-.006,6.3-.007a2.385,2.385,0,0,0,.541-.023c.365-.086.692-.322.6-.7a1.263,1.263,0,0,0-.6-.646,1.487,1.487,0,0,0-.693-.054q-5.133,0-10.267,0a6.617,6.617,0,0,1-1.028-.061,1.6,1.6,0,0,1-1.361-1.419,1.566,1.566,0,0,1,1.224-1.532,3.535,3.535,0,0,1,.859-.1c4.436-.006,8.872-.014,13.309,0a8.036,8.036,0,0,1,7.916,5.325,7.736,7.736,0,0,1,.352,4.062c-.014.078-.024.156-.034.234a.308.308,0,0,0,.306.35c.2-.011.287-.235.365-.427a7.765,7.765,0,0,0-.1-6.323C547.039,512.718,546.945,512.535,546.844,512.344Z"
              transform="translate(-522.159 -509.677)"
              fill="#f0324c"
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M534.478,583.111c-.362,0-.725.018-1.086,0a1.446,1.446,0,0,1-1.454-1.395,1.393,1.393,0,0,1,1.4-1.377,19.78,19.78,0,0,1,2.333,0,1.422,1.422,0,0,1,1.413,1.432,1.5,1.5,0,0,1-1.52,1.345c-.362.015-.724,0-1.086,0Z"
              transform="translate(-530.034 -571.359)"
              fill="#f0324c"
            />
            <path
              id="Path_31"
              data-name="Path 31"
              d="M516.9,547.167a1.472,1.472,0,1,1,2.944-.03,1.518,1.518,0,0,1-1.433,1.48A1.494,1.494,0,0,1,516.9,547.167Z"
              transform="translate(-516.898 -541.106)"
              fill="#f0324c"
            />
          </g>
        </g>
        <path
          id="Path_32"
          data-name="Path 32"
          d="M634.4,667.364l10.157,2.642a2.262,2.262,0,0,0,2.684-.958l.6-.989a1.114,1.114,0,0,1,1.36-.457l1.067.42a2.483,2.483,0,0,1,1.3,3.453c-1.012,1.955-2.257,4.375-2.257,4.375a4.02,4.02,0,0,1-4.68,2.028l-18.665-4.594a.492.492,0,0,1-.178-.846l4.93-4.182A3.47,3.47,0,0,1,634.4,667.364Z"
          transform="translate(-611.854 -647.231)"
          fill="#f0324c"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
